import { Component, OnInit } from '@angular/core';
import { SpecTableComponent } from '../spec-table/spec-table.component';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-cvlanspec-table',
  templateUrl: './cvlanspec-table.component.html',
  styleUrls: ['./cvlanspec-table.component.scss']
})
export class CVLANSpecTableComponent extends SpecTableComponent implements OnInit {

  constructor(
    router: Router,
    activatedRoute: ActivatedRoute,
  ) {
    super(router, activatedRoute);
  }

  ngOnInit() {
    this.displayedColumns = ['name', 'totalPorts', 'occupancy', 'territoryUser'];
    super.onInit();
  }
}
